// النصوص اللي ليها نسخة عربي وإنجليزي: `field` هو العربي (أو الإنجليزي لو العربي فاضي) و `fieldEn` هو الإنجليزي.
// العرض بلغة الواجهة، ولو مش موجودة بنعرض اللغة التانية.
export const localizedText = (item, field, lang = 'ar') => {
    const main = String(item?.[field] ?? '').trim();
    const english = String(item?.[`${field}En`] ?? '').trim();
    return lang === 'en' ? (english || main) : (main || english);
};

// قيمة الحقل العربي في نماذج التعديل: لو السيرفر حط الإنجليزي مكان العربي (لأنه كان فاضي) بنرجّعه فاضي.
export const arabicValueForEdit = (item, field) => {
    const main = String(item?.[field] ?? '');
    const english = String(item?.[`${field}En`] ?? '');
    return main && english && main.trim() === english.trim() ? '' : main;
};

// فيه نسخة إنجليزي مختلفة عن العربي في أي حقل من الحقول (عشان نظهر زرار تبديل العرض).
export const hasBothLanguages = (item, fields = []) => fields.some((field) => {
    const main = String(item?.[field] ?? '').trim();
    const english = String(item?.[`${field}En`] ?? '').trim();
    return Boolean(main && english && main !== english);
});

const LANG_NAMES = { ar: { ar: 'العربية', en: 'Arabic' }, en: { ar: 'الإنجليزية', en: 'English' } };
const plainText = (value) => String(value ?? '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').trim();

// تحقق الحقول العربي / الإنجليزي:
//  - لازم لغة واحدة على الأقل تكون كاملة.
//  - أي لغة اتكتب فيها حاجة لازم تتكمل (مايتحفظش عنوان إنجليزي من غير محتوى إنجليزي مثلاً).
// fields: [{ key, label, required, ar, en }] — القيم ممكن تكون HTML (المحرر).
// بيرجع { errors: { ar: { key: msg }, en: {...} }, messages: [{ lang, text }], firstLang, valid }.
export const validateBilingual = (fields, { isAr = true, preferredLang = 'ar' } = {}) => {
    const errors = { ar: {}, en: {} };
    const messages = [];
    const filled = (field, lang) => Boolean(plainText(field[lang]));
    const used = ['ar', 'en'].filter((lang) => fields.some((field) => filled(field, lang)));
    const langName = (lang) => (isAr ? LANG_NAMES[lang].ar : LANG_NAMES[lang].en);

    if (!used.length) {
        const lang = preferredLang === 'en' ? 'en' : 'ar';
        fields.filter((field) => field.required).forEach((field) => {
            const text = isAr ? `${field.label} مطلوب (بالعربي أو بالإنجليزي)` : `${field.label} is required (Arabic or English)`;
            errors[lang][field.key] = text;
            messages.push({ lang, text });
        });
    } else {
        used.forEach((lang) => {
            fields.filter((field) => field.required && !filled(field, lang)).forEach((field) => {
                const text = isAr
                    ? `${field.label} ناقص في النسخة ${langName(lang)} — أكمله أو امسح باقي النسخة ${langName(lang)}`
                    : `${field.label} is missing in the ${langName(lang)} version — fill it or clear the ${langName(lang)} version`;
                errors[lang][field.key] = text;
                messages.push({ lang, text });
            });
        });
    }

    return {
        errors,
        messages,
        firstLang: messages[0]?.lang || null,
        valid: messages.length === 0,
    };
};
